/**
 * GL Wishlist — lightweight, localStorage-based wishlist for product cards.
 * - Persists across sessions using localStorage.
 * - Only runs click handlers when the document is visible (prevents background tab issues).
 * - Heart fills red on toggle.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'gl_wishlist_items';

  /* ── helpers ───────────────────────────────────────── */
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isWishlisted(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
  }

  function toggleWishlist(productId) {
    const id = String(productId);
    let list = getWishlist();
    const idx = list.indexOf(id);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(id);
    }
    saveWishlist(list);
    return idx === -1; // true = now wishlisted
  }

  /* ── render initial state ─────────────────────────── */
  function syncButtons() {
    document.querySelectorAll('.gl-wishlist-btn').forEach(function (btn) {
      const pid = btn.getAttribute('data-product-id');
      if (isWishlisted(pid)) {
        btn.classList.add('wishlisted');
      } else {
        btn.classList.remove('wishlisted');
      }
    });
  }

  /* ── event delegation (single listener on body) ───── */
  function handleClick(e) {
    // Don't fire when tab is hidden / in background
    if (document.hidden) return;

    const btn = e.target.closest('.gl-wishlist-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const pid = btn.getAttribute('data-product-id');
    if (!pid) return;

    const nowWishlisted = toggleWishlist(pid);

    // Update ALL buttons for this product (may appear in multiple sections)
    document.querySelectorAll('.gl-wishlist-btn[data-product-id="' + pid + '"]').forEach(function (b) {
      if (nowWishlisted) {
        b.classList.add('wishlisted');
        // Re-trigger the pop animation
        b.style.animation = 'none';
        // Force reflow
        void b.offsetWidth;
        b.style.animation = '';
      } else {
        b.classList.remove('wishlisted');
      }
    });
  }

  /* ── init ──────────────────────────────────────────── */
  function init() {
    syncButtons();
    document.body.addEventListener('click', handleClick);

    // Re-sync when a tab becomes visible again (multi-tab support)
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) syncButtons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
